import { render, staticRenderFns } from "./InputPercentage.vue?vue&type=template&id=684e4b1a&scoped=true"
import script from "./InputPercentage.vue?vue&type=script&lang=ts"
export * from "./InputPercentage.vue?vue&type=script&lang=ts"
import style0 from "./InputPercentage.vue?vue&type=style&index=0&id=684e4b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e4b1a",
  null
  
)

export default component.exports